import { State } from '../../reducer';
import { namespace } from './';
import { createSelector } from 'reselect';

const getCustomerSelectorState = (state: State) => state[namespace].customer;
export const getCustomerSelector = createSelector([getCustomerSelectorState], (s) => s);

const getIsNotFoundSelectorState = (state: State) => state[namespace].isNotFound;
export const getIsNotFoundSelector = createSelector([getIsNotFoundSelectorState], (s) => s);

const getDeleteCustomerModalOpenSelectorState = (state: State) => state[namespace].deleteCustomerModalOpen;
export const deleteCustomerModalOpenSelector = createSelector([getDeleteCustomerModalOpenSelectorState], (s) => s);

const getChangeCustomerIdModalOpenSelectorState = (state: State) => state[namespace].changeCustomerIdModalOpen;
export const changeCustomerIdModalOpenSelector = createSelector([getChangeCustomerIdModalOpenSelectorState], (s) => s);

const getChangeCustomerIdErrorSelectorState = (state: State) => state[namespace].changeCustomerIdError;
export const getChangeCustomerIdErrorSelector = createSelector([getChangeCustomerIdErrorSelectorState], (s) => s);

const getTokensSelectorState = (state: State) => state[namespace].tokens;
export const getTokensSelector = createSelector([getTokensSelectorState], (s) => s);

const getBasicInfoUpdatesState = (state: State) => state[namespace].basicInfoUpdates;
export const getBasicInfoUpdatesSelector = createSelector([getBasicInfoUpdatesState], (s) => s);
